module.exports = __webpack_public_path__ + "static/media/7.6540e881.jpg";